import React from "react";
import PropTypes from "prop-types";
import { LoadingScreenLayout } from "../layout/LoadingScreenLayout";
import { useRandomMessageTransition } from "./hooks/useRandomMessageTransition";
import styles from "./LoadingScreen.scss";

const MB = 1024 * 1024;

export function LoadingScreen({ message, infoMessages, sceneDownload }) {
  const infoMessage = useRandomMessageTransition(infoMessages);
  const { bytesLoaded, bytesTotal } = sceneDownload;
  const downloading = bytesTotal > 0 && bytesLoaded < bytesTotal;
  const percent = bytesTotal ? Math.floor((bytesLoaded / bytesTotal) * 100) : 0;

  return (
    <LoadingScreenLayout
      center={
        <div className={styles.progress}>
          <div className={styles.label}>
            {downloading ? `${percent}% (${(bytesLoaded / MB).toFixed(1)}/${(bytesTotal / MB).toFixed(1)}MB)` : message}
          </div>
          <div className={styles.track}>
            <div className={styles.fill} style={{ width: `${percent}%` }} />
          </div>
        </div>
      }
      bottom={
        <>
          <h3>{infoMessage.heading}</h3>
          <p>{infoMessage.message}</p>
        </>
      }
    />
  );
}

LoadingScreen.propTypes = {
  message: PropTypes.node,
  infoMessages: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.node.isRequired,
      message: PropTypes.node.isRequired
    })
  ),
  sceneDownload: PropTypes.shape({
    bytesLoaded: PropTypes.number.isRequired,
    bytesTotal: PropTypes.number.isRequired
  })
};

LoadingScreen.defaultProps = {
  infoMessages: [],
  sceneDownload: { bytesLoaded: 0, bytesTotal: 0 }
};
